import { render } from "./LabelTextInput.vue?vue&type=template&id=be25b372"
import script from "./LabelTextInput.vue?vue&type=script&lang=js"
export * from "./LabelTextInput.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__